import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const o = r((l, a) => /* @__PURE__ */ s.jsx(
  e,
  {
    ref: a,
    ...l,
    image: (i) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...i,
        children: [
          /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_2974_3729)", children: [
            /* @__PURE__ */ s.jsxs(
              "mask",
              {
                id: "mask0_2974_3729",
                width: 16,
                height: 16,
                x: 0,
                y: 0,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: [
                  /* @__PURE__ */ s.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M13.22 9.86c-2.02 0-3.48 1.01-4.47 2.23V4.74a.749.749 0 1 0-1.5 0v7.51C6.32 11 4.88 9.81 2.78 9.81c-.41 0-.75.34-.75.75s.34.75.75.75c3.19 0 4.45 4.12 4.46 4.16.1.31.39.53.72.53h.02c.34-.01.63-.24.71-.57.04-.17 1.07-4.07 4.53-4.07.41 0 .75-.34.75-.75s-.34-.75-.75-.75"
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M14.8 0H1.2C.54 0 0 .53 0 1.19v5.45a.749.749 0 1 0 1.5 0V1.5h13v5.14a.749.749 0 1 0 1.5 0V1.19C16 .53 15.46 0 14.8 0"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3729)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
          ] }),
          /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_2974_3729", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
o.displayName = "AgencyDownloadIcon";
export {
  o as AgencyDownloadIcon,
  o as default
};
//# sourceMappingURL=index.js.map
